(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-announcement-bar')) {
    const ITEM = '.ann-item';
    const MIN_INTERVAL_S = 1.5;

    customElements.define(
      'sx-announcement-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.sx-ann__track');
          this.group = this.querySelector('.sx-ann__group');
          if (!this.track || !this.group) return;
          this.index = 0;
          if (this.dataset.mode === 'marquee') {
            this.setupMarquee();
          } else {
            this.setupRotate();
          }
          this.onBlockSelect = (event) => this.selectBlock(event);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
          this.mutations?.disconnect();
          this.resize?.disconnect();
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        items() {
          return Array.from(this.group.querySelectorAll(ITEM));
        }

        setupMarquee() {
          this.track.querySelectorAll('[data-ann-copy]').forEach((el) => el.remove());
          const copy = this.group.cloneNode(true);
          copy.setAttribute('data-ann-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('inert', '');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
            Array.from(el.attributes)
              .filter((attr) => attr.name.startsWith('data-shopify'))
              .forEach((attr) => el.removeAttribute(attr.name));
          });
          copy.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          this.track.appendChild(copy);
        }

        setupRotate() {
          this.classList.add('is-ready');
          this.activate();
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const interval = Math.max(Number(this.dataset.interval) || 2.5, MIN_INTERVAL_S) * 1000;
          if (!reduced) {
            this.timer = window.setInterval(() => {
              if (document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
              this.index += 1;
              this.activate();
            }, interval);
          }
          this.mutations = new MutationObserver(() => this.activate());
          this.mutations.observe(this.group, { childList: true });
          if ('ResizeObserver' in window) {
            this.resize = new ResizeObserver(() => this.measure());
            this.resize.observe(this.track);
          }
        }

        measure() {
          const tallest = this.items().reduce((max, el) => Math.max(max, el.offsetHeight), 0);
          if (tallest) this.track.style.setProperty('--ann-h', `${tallest}px`);
        }

        activate() {
          const items = this.items();
          if (!items.length) return;
          this.measure();
          this.index %= items.length;
          items.forEach((el, i) => {
            const active = i === this.index;
            el.classList.toggle('is-active', active);
            el.toggleAttribute('inert', !active);
          });
        }

        selectBlock(event) {
          if (this.dataset.mode === 'marquee' || !this.contains(event.target)) return;
          const index = this.items().indexOf(event.target.closest(ITEM));
          if (index < 0) return;
          this.index = index;
          this.activate();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-before-after')) {
    customElements.define(
      'sx-before-after',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.ba__input');
          if (!this.input) return;
          this.dragging = false;
          this.addEventListener('pointerdown', (event) => this.onPointerDown(event));
          this.addEventListener('pointermove', (event) => {
            if (this.dragging) this.moveTo(event.clientX);
          });
          this.addEventListener('pointerup', () => this.stopDrag());
          this.addEventListener('pointercancel', () => this.stopDrag());
          this.input.addEventListener('input', () => this.setPos(Number(this.input.value)));
        }

        setPos(value) {
          const pos = Math.min(100, Math.max(0, value));
          const rounded = Math.round(pos);
          this.style.setProperty('--pos', `${pos}%`);
          this.input.value = String(rounded);
          this.input.setAttribute('aria-valuetext', `${rounded}%`);
        }

        moveTo(clientX) {
          const rect = this.getBoundingClientRect();
          if (!rect.width) return;
          this.setPos(Math.round(((clientX - rect.left) / rect.width) * 1000) / 10);
        }

        onPointerDown(event) {
          if (event.button !== 0) return;
          this.setPointerCapture(event.pointerId);
          this.dragging = true;
          this.classList.add('is-dragging');
          this.moveTo(event.clientX);
          this.input.focus({ preventScroll: true });
        }

        stopDrag() {
          this.dragging = false;
          this.classList.remove('is-dragging');
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-cart-drawer')) {
    customElements.define(
      'sx-cart-drawer',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          const theme = window.SxTheme;
          this.onOpen = () => this.open();
          document.addEventListener(theme.events.openCart, this.onOpen);

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-cart-note]')) this.saveNote(event.target);
          });
          this.addEventListener('click', (event) => {
            if (!event.target.closest('[data-drawer-close-link]')) return;
            if (window.location.pathname === new URL(event.target.closest('a').href).pathname) {
              event.preventDefault();
              this.drawer()?.close();
            }
          });

          this.onSectionSelect = (event) => {
            if (event.detail?.sectionId && this.closest(`#shopify-section-${CSS.escape(event.detail.sectionId)}`)) this.open();
          };
          this.onSectionDeselect = (event) => {
            if (event.detail?.sectionId && this.closest(`#shopify-section-${CSS.escape(event.detail.sectionId)}`)) this.drawer()?.close();
          };
          document.addEventListener('shopify:section:select', this.onSectionSelect);
          document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        }

        disconnectedCallback() {
          const theme = window.SxTheme;
          if (theme) document.removeEventListener(theme.events.openCart, this.onOpen);
          document.removeEventListener('shopify:section:select', this.onSectionSelect);
          document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
          this.bound = false;
        }

        drawer() {
          return document.getElementById(this.dataset.drawer);
        }

        open() {
          const drawer = this.drawer();
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }

        async saveNote(textarea) {
          const error = this.querySelector('[data-note-error]');
          if (error) error.hidden = true;
          try {
            const response = await fetch(`${this.dataset.cartUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: textarea.value }),
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
          } catch (failure) {
            if (!error) return;
            error.textContent = window.SxTheme?.strings?.cartError || failure.message;
            error.hidden = false;
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-content-tabs')) {
    customElements.define(
      'sx-content-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[role="tablist"]');
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.list || !this.tabs.length) return;
          this.indicator = this.list.querySelector('.ctabs__indicator');
          this.active = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
          this.abort = new AbortController();
          const { signal } = this.abort;

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index), { signal });
            tab.addEventListener('keydown', (event) => this.onKeyDown(event, index), { signal });
          });

          this.addEventListener('shopify:block:select', (event) => {
            const panel = event.target.closest?.('[role="tabpanel"]');
            const index = this.tabs.findIndex((tab) => tab.getAttribute('aria-controls') === panel?.id);
            if (index >= 0) this.select(index);
          }, { signal });

          this.measure = this.measure.bind(this);
          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(this.list);
          this.select(this.active);
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }

        panelFor(tab) {
          const id = tab.getAttribute('aria-controls');
          return id ? document.getElementById(id) : null;
        }

        select(index, focus = false) {
          this.active = index;
          this.tabs.forEach((tab, i) => {
            const selected = i === index;
            tab.classList.toggle('is-active', selected);
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            const panel = this.panelFor(tab);
            if (!panel) return;
            panel.classList.toggle('is-active', selected);
            panel.tabIndex = selected ? 0 : -1;
            if (selected) {
              panel.removeAttribute('aria-hidden');
              panel.removeAttribute('inert');
            } else {
              panel.setAttribute('aria-hidden', 'true');
              panel.setAttribute('inert', '');
            }
          });
          this.reveal(index);
          this.measure();
          if (focus) this.tabs[index].focus();
        }

        /* Keeps the active tab visible inside the horizontally scrollable bar without moving the page. */
        reveal(index) {
          const tab = this.tabs[index];
          const left = tab.offsetLeft - 12;
          const right = tab.offsetLeft + tab.offsetWidth + 12;
          if (left < this.list.scrollLeft) this.list.scrollLeft = left;
          else if (right > this.list.scrollLeft + this.list.clientWidth) this.list.scrollLeft = right - this.list.clientWidth;
        }

        measure() {
          const tab = this.tabs[this.active];
          if (!tab || !this.indicator) return;
          this.indicator.style.width = `${tab.offsetWidth}px`;
          this.indicator.style.transform = `translate3d(${tab.offsetLeft}px, 0, 0)`;
          this.list.classList.add('is-measured');
        }

        onKeyDown(event, index) {
          const count = this.tabs.length;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % count;
          else if (event.key === 'ArrowLeft') next = (index - 1 + count) % count;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = count - 1;
          else return;
          event.preventDefault();
          this.select(next, true);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-cdb-timer')) {
    customElements.define(
      'sx-cdb-timer',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Number(this.dataset.end);
          if (!Number.isFinite(this.end) || this.end <= 0) return;
          this.units = {};
          this.querySelectorAll('[data-unit]').forEach((unit) => {
            this.units[unit.dataset.unit] = { unit, value: unit.querySelector('[data-value]') };
          });
          this.tick = this.tick.bind(this);
          this.tick();
          this.timer = window.setInterval(this.tick, 1000);
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
        }

        tick() {
          const left = Math.max(0, this.end - Date.now());
          if (left <= 0) {
            window.clearInterval(this.timer);
            // Campaign over: remove the whole banner (never show a finished or restarting timer).
            const root = this.closest('[data-cdb-root]') || this;
            root.remove();
            return;
          }
          const pad = (n) => String(n).padStart(2, '0');
          const parts = {
            days: Math.floor(left / 86400000),
            hours: Math.floor((left / 3600000) % 24),
            minutes: Math.floor((left / 60000) % 60),
            seconds: Math.floor((left / 1000) % 60),
          };
          Object.entries(parts).forEach(([key, value]) => {
            const entry = this.units[key];
            if (!entry) return;
            if (entry.value.textContent !== pad(value)) entry.value.textContent = pad(value);
            if (key === 'days') entry.unit.hidden = value === 0;
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-header')) {
    const SCROLL_HIDE_OFFSET = 120;
    const SCROLLED_ON = 24;
    const SCROLLED_OFF = 4;
    const DIRECTION_DELTA = 8;
    const CLOSE_DELAY_MS = 120;

    customElements.define(
      'sx-header',
      class extends HTMLElement {
        connectedCallback() {
          this.header = this.querySelector('.sx-hd');
          if (!this.header) return;
          this.hideOnScroll = this.dataset.sticky === 'scroll-up';
          this.lastY = 0;
          this.isHidden = false;
          this.isScrolled = false;

          this.onScroll = () => {
            if (this.frame) return;
            this.frame = window.requestAnimationFrame(() => {
              this.frame = 0;
              this.updateScroll();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.updateScroll();

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              document.documentElement.style.setProperty('--sx-header-h', `${Math.round(this.header.offsetHeight)}px`);
            });
            this.resizeObserver.observe(this.header);
          }

          this.placeCards();
          this.setupNav();
          this.setupMobileMenu();
          this.setupCartLink();

          this.onBlockSelect = (event) => this.toggleCardMenu(event, true);
          this.onBlockDeselect = (event) => this.toggleCardMenu(event, false);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.cancelAnimationFrame(this.frame);
          this.resizeObserver?.disconnect();
          document.removeEventListener('keydown', this.onKeydown);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
          window.clearTimeout(this.closeTimer);
        }

        updateScroll() {
          const y = Math.max(window.scrollY, 0);
          this.isScrolled = this.isScrolled ? y > SCROLLED_OFF : y > SCROLLED_ON;
          this.header.classList.toggle('is-scrolled', this.isScrolled);
          const delta = y - this.lastY;
          if (y <= SCROLL_HIDE_OFFSET) {
            this.setHidden(false);
            this.lastY = y;
            return;
          }
          if (Math.abs(delta) < DIRECTION_DELTA) return;
          const keepVisible = this.header.contains(document.activeElement) || this.querySelector('.sx-nav__item.is-open');
          this.setHidden(delta > 0 && !keepVisible);
          this.lastY = y;
        }

        setHidden(hidden) {
          const next = this.hideOnScroll && hidden;
          if (next === this.isHidden) return;
          this.isHidden = next;
          this.header.classList.toggle('is-hidden', next);
        }

        placeCards() {
          this.querySelectorAll('.sx-hd__cards-src [data-menu-card]').forEach((card) => {
            const key = card.dataset.menuCard;
            if (!key) return;
            const slot = this.querySelector(`.sx-mega[data-menu="${CSS.escape(key)}"] .sx-mega__cards`);
            if (slot) slot.appendChild(card);
          });
        }

        setupNav() {
          this.nav = this.header.querySelector('.sx-nav');
          if (!this.nav) return;
          this.items = Array.from(this.nav.querySelectorAll('.sx-nav__item'));
          this.items.forEach((item) => {
            const hasSub = item.classList.contains('has-sub');
            item.addEventListener('mouseenter', () => (hasSub ? this.openItem(item) : this.scheduleClose()));
            item.addEventListener('focusin', () => {
              if (hasSub) this.openItem(item);
              else this.closeItems();
            });
            const link = item.querySelector(':scope > .sx-nav__link');
            if (!hasSub || !link) return;
            link.addEventListener('pointerdown', (event) => {
              this.lastPointer = event.pointerType;
            });
            link.addEventListener('click', (event) => {
              if (this.lastPointer === 'touch' && !item.classList.contains('is-open')) {
                event.preventDefault();
                this.openItem(item);
              }
            });
          });
          this.nav.addEventListener('mouseleave', () => this.scheduleClose());
          this.nav.addEventListener('focusout', (event) => {
            if (!this.nav.contains(event.relatedTarget)) this.closeItems();
          });
          this.onKeydown = (event) => {
            if (event.key !== 'Escape') return;
            const open = this.nav.querySelector('.sx-nav__item.is-open');
            if (!open) return;
            const focusInside = open.contains(document.activeElement);
            this.closeItems();
            if (focusInside) open.querySelector(':scope > .sx-nav__link')?.focus();
          };
          document.addEventListener('keydown', this.onKeydown);
        }

        openItem(target) {
          window.clearTimeout(this.closeTimer);
          this.items.forEach((item) => {
            const open = item === target;
            item.classList.toggle('is-open', open);
            const link = item.querySelector(':scope > .sx-nav__link[aria-expanded]');
            if (link) link.setAttribute('aria-expanded', String(open));
          });
        }

        closeItems() {
          window.clearTimeout(this.closeTimer);
          this.openItem(null);
        }

        scheduleClose() {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = window.setTimeout(() => this.closeItems(), CLOSE_DELAY_MS);
        }

        toggleCardMenu(event, open) {
          const card = event.target.closest?.('[data-menu-card]');
          if (!card || !this.contains(card) || !this.items) return;
          const item = card.closest('.sx-nav__item');
          if (!item) return;
          if (open) this.openItem(item);
          else this.closeItems();
        }

        setupMobileMenu() {
          this.addEventListener('click', (event) => {
            const toggle = event.target.closest('.sx-mm__toggle');
            if (toggle) {
              const item = toggle.closest('.sx-mm__item');
              const open = !item.classList.contains('is-open');
              item.classList.toggle('is-open', open);
              toggle.setAttribute('aria-expanded', String(open));
              return;
            }
            const searchButton = event.target.closest('[data-mm-search]');
            if (!searchButton) return;
            const menu = searchButton.closest('sx-drawer');
            const search = document.getElementById(searchButton.dataset.mmSearch);
            if (menu && typeof menu.close === 'function') menu.close({ immediate: true });
            if (search && typeof search.open === 'function') search.open(searchButton);
          });
        }

        setupCartLink() {
          const link = this.querySelector('[data-cart-open]');
          if (!link) return;
          link.addEventListener('click', (event) => {
            const theme = window.SxTheme;
            if (!theme || theme.cartType !== 'drawer' || this.dataset.template === 'cart') return;
            if (!document.querySelector('sx-cart-drawer')) return;
            event.preventDefault();
            theme.emit(theme.events.openCart, { opener: link });
          });
        }
      },
    );
  }

  if (!customElements.get('sx-predictive-search')) {
    const MIN_CHARS = 2;
    const MAX_RESULTS = 6;
    const SEARCH_DEBOUNCE_MS = 250;

    customElements.define(
      'sx-predictive-search',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[type="search"]');
          this.output = this.querySelector('[data-search-results]');
          this.popular = this.querySelector('[data-search-popular]');
          if (!this.input || !this.output) return;
          this.input.addEventListener('input', () => {
            window.clearTimeout(this.debounce);
            this.debounce = window.setTimeout(() => this.search(this.input.value), SEARCH_DEBOUNCE_MS);
          });
          this.addEventListener('click', (event) => {
            const chip = event.target.closest('[data-search-term]');
            if (!chip) return;
            this.input.value = chip.dataset.searchTerm;
            this.input.focus();
            this.search(this.input.value);
          });
        }

        disconnectedCallback() {
          window.clearTimeout(this.debounce);
          this.controller?.abort();
        }

        message(text, className) {
          const p = document.createElement('p');
          p.className = className;
          p.textContent = text;
          return p;
        }

        async search(raw) {
          const term = raw.trim();
          this.controller?.abort();
          if (term.length < MIN_CHARS) {
            this.output.replaceChildren();
            this.output.classList.remove('is-loading');
            if (this.popular) this.popular.hidden = false;
            return;
          }
          if (this.popular) this.popular.hidden = true;
          if (!this.output.querySelector('.sx-search__results')) {
            const loading = document.createElement('div');
            loading.className = 'sx-search__loading';
            loading.innerHTML = '<span class="sx-spinner"></span>';
            loading.setAttribute('aria-label', this.dataset.loading || '');
            this.output.replaceChildren(loading);
          }
          this.output.classList.add('is-loading');

          const controller = new AbortController();
          this.controller = controller;
          const params = new URLSearchParams({
            q: term,
            'resources[type]': 'product',
            'resources[limit]': String(MAX_RESULTS),
            'resources[options][unavailable_products]': 'last',
            section_id: 'predictive-search',
          });
          try {
            const response = await fetch(`${this.dataset.url}?${params.toString()}`, { signal: controller.signal });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = await response.text();
            if (controller !== this.controller) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const results = doc.querySelector('[data-predictive-results]');
            const list = results?.querySelector('.sx-search__results');
            if (!list || Number(results.dataset.count) === 0) {
              this.output.replaceChildren(this.message(this.dataset.noResults, 'sx-search__empty'));
            } else {
              const viewAll = document.createElement('a');
              viewAll.className = 'sx-btn sx-btn--secondary sx-btn--block';
              viewAll.href = `${this.dataset.searchUrl}?${new URLSearchParams({ q: term, 'options[prefix]': 'last' }).toString()}`;
              viewAll.textContent = this.dataset.viewAll;
              this.output.replaceChildren(document.importNode(list, true), viewAll);
            }
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.output.replaceChildren(this.message(this.dataset.error, 'sx-search__empty sx-search__error'));
          } finally {
            if (controller === this.controller) this.output.classList.remove('is-loading');
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-hero-slideshow')) {
    const SWIPE_THRESHOLD = 48;

    class SxHeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hero-show__track');
        this.slides = Array.from(this.querySelectorAll('.hero-slide'));
        if (!this.track || !this.slides.length) return;

        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.duration = Number(this.dataset.autoplayMs || 0);
        this.remaining = this.duration;
        this.index = 0;
        this.pauses = new Set();
        this.timer = null;
        this.swipeX = null;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.goTo(this.index - 1), { signal });
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.goTo(this.index + 1), { signal });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.heroDot)), { signal }));

        this.addEventListener('keydown', (event) => this.onKeyDown(event), { signal });
        this.addEventListener('pointerenter', (event) => event.pointerType === 'mouse' && this.setPause('hover', true), { signal });
        this.addEventListener('pointerleave', (event) => event.pointerType === 'mouse' && this.setPause('hover', false), { signal });
        this.addEventListener('focusin', () => this.setPause('focus', true), { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setPause('focus', false);
        }, { signal });

        this.track.addEventListener('pointerdown', (event) => {
          this.swipeX = event.pointerType === 'mouse' ? null : event.clientX;
        }, { signal });
        this.track.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
        this.track.addEventListener('pointercancel', () => {
          this.swipeX = null;
        }, { signal });

        document.addEventListener('visibilitychange', () => this.setPause('hidden', document.hidden), { signal });
        this.motionQuery.addEventListener('change', () => this.refresh(), { signal });

        /* Theme editor: show the selected slide and hold it while it is being edited. */
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest?.('.hero-slide');
          const index = this.slides.indexOf(slide);
          if (index < 0) return;
          this.setPause('editor', true);
          this.goTo(index);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => this.setPause('editor', false), { signal });

        this.classList.add('is-ready');
        this.refresh();
      }

      disconnectedCallback() {
        this.abort?.abort();
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      get multi() {
        return this.slides.length > 1;
      }

      get autoplaying() {
        return this.multi && this.duration > 0 && !this.motionQuery.matches;
      }

      refresh() {
        this.track.setAttribute('aria-live', this.autoplaying ? 'off' : 'polite');
        this.render();
        this.restartProgress();
        this.schedule();
      }

      goTo(target) {
        const count = this.slides.length;
        if (!count) return;
        this.index = ((target % count) + count) % count;
        this.remaining = this.duration;
        this.render();
        this.restartProgress();
        this.schedule();
      }

      render() {
        const animate = !this.motionQuery.matches;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-animated', animate);
          if (active) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.toggle('is-active', active);
          dot.classList.toggle('has-progress', this.autoplaying);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      restartProgress() {
        const fill = this.dots[this.index]?.querySelector('.hero-show__dot-fill');
        if (!fill) return;
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }

      schedule() {
        window.clearTimeout(this.timer);
        this.timer = null;
        if (!this.autoplaying || this.pauses.size > 0) return;
        this.startedAt = performance.now();
        this.timer = window.setTimeout(() => this.goTo(this.index + 1), this.remaining);
      }

      setPause(reason, on) {
        if (this.pauses.has(reason) === on) return;
        const wasPaused = this.pauses.size > 0;
        if (on) this.pauses.add(reason);
        else this.pauses.delete(reason);
        const isPaused = this.pauses.size > 0;
        this.classList.toggle('is-paused', isPaused);
        if (!wasPaused && isPaused && this.timer) {
          window.clearTimeout(this.timer);
          this.timer = null;
          this.remaining = Math.max(0, this.remaining - (performance.now() - this.startedAt));
        } else if (wasPaused && !isPaused) {
          this.schedule();
        }
      }

      onKeyDown(event) {
        if (!this.multi || event.target.closest('input, textarea, select')) return;
        if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        else if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
        else return;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (this.swipeX === null || !this.multi) return;
        const delta = event.clientX - this.swipeX;
        this.swipeX = null;
        if (Math.abs(delta) < SWIPE_THRESHOLD) return;
        this.goTo(delta < 0 ? this.index + 1 : this.index - 1);
      }
    }

    customElements.define('sx-hero-slideshow', SxHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-cloud"] && !Shopify.designMode) return;
  try {
    
  /* Fills the scrolling logo strip: repeats the logos inside the list, then adds one hidden copy. */
  if (!customElements.get('sx-logo-marquee')) {
    customElements.define(
      'sx-logo-marquee',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.repeat || this.classList.contains('is-ready')) return;
          const track = this.querySelector('.logos__track');
          const list = track?.querySelector('.logos__list');
          if (!list) return;
          const originals = Array.from(list.querySelectorAll('.logos__item'));
          if (!originals.length) return;
          const repeat = Math.max(1, Number(this.dataset.repeat || 1));

          const decorate = (node) => {
            node.setAttribute('aria-hidden', 'true');
            node.removeAttribute('data-shopify-editor-block');
            node.querySelectorAll('img').forEach((img) => img.setAttribute('alt', ''));
            node.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
            return node;
          };

          for (let r = 1; r < repeat; r += 1) {
            originals.forEach((item) => {
              const clone = decorate(item.cloneNode(true));
              clone.classList.add('logos__item--dup');
              list.appendChild(clone);
            });
          }

          const copy = list.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('.logos__item').forEach(decorate);
          track.appendChild(copy);
          this.classList.add('is-ready');
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-confirm]');
    if (form && !window.confirm(form.dataset.confirm)) event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('sx-cart-recommendations')) {
    customElements.define(
      'sx-cart-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.loaded || !this.dataset.url) return;
          this.loaded = true;
          if (!('IntersectionObserver' in window)) {
            this.load();
            return;
          }
          this.hidden = false;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.load();
            },
            { rootMargin: '0px 0px 400px 0px' },
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        async load() {
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const recs = doc.querySelector('[data-cart-recs]');
            if (!recs || !recs.children.length) {
              this.hidden = true;
              return;
            }
            this.replaceChildren(...Array.from(recs.childNodes).map((node) => document.importNode(node, true)));
            this.hidden = false;
          } catch (error) {
            this.hidden = true;
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  customElements.whenDefined('sx-modal').then(() => {
    document.querySelectorAll('sx-modal[data-password-modal]').forEach((modal) => {
      if (modal.querySelector('[data-password-error]') && typeof modal.open === 'function') modal.open();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    if (window.SxPdp) return;

    const QTY_KEY = '__sxPdpQuantity';
    const controllers = new Map();
    const eventName = (key, fallback) => window.SxTheme?.events?.[key] || fallback;

    const pdp = {
      /* Quantity chosen by quantity-break cards; stored so a buy block that connects later still reads it. */
      publishQuantity(productId, quantity) {
        window[QTY_KEY] = { productId: String(productId), quantity };
        document.dispatchEvent(
          new CustomEvent(eventName('quantity', 'sx:pdp-quantity'), { detail: { productId: String(productId), quantity } }),
        );
      },

      readQuantity(productId) {
        const stored = window[QTY_KEY];
        return stored && stored.productId === String(productId) && stored.quantity > 0 ? stored.quantity : null;
      },

      form(sectionId) {
        return document.getElementById(`product-form-${sectionId}`);
      },

      /* FormData includes inputs associated through the form="" attribute, so blocks can live anywhere. */
      properties(form) {
        const properties = {};
        if (!form) return properties;
        new FormData(form).forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value.trim() !== '') properties[match[1]] = value.trim();
        });
        return properties;
      },

      personalizations(sectionId) {
        return Array.from(document.querySelectorAll(`sx-personalization[data-section-id="${sectionId}"]`));
      },

      hasRequiredPersonalization(sectionId) {
        return pdp.personalizations(sectionId).some((el) => el.dataset.required === 'true');
      },

      validate(sectionId) {
        let valid = true;
        pdp.personalizations(sectionId).forEach((el) => {
          if (typeof el.validate !== 'function') return;
          const ok = el.validate(valid);
          if (!ok) valid = false;
        });
        return valid;
      },

      /* Cart lines for the current selection. A personalization block with one message per unit splits
         the quantity into lines grouped by message; otherwise a single line carries the form properties. */
      lineItems(sectionId, variantId, quantity) {
        const properties = pdp.properties(pdp.form(sectionId));
        const perso = pdp.personalizations(sectionId).find((el) => typeof el.lineItems === 'function');
        const items = perso ? perso.lineItems(variantId, quantity, properties) : [{ id: variantId, quantity, properties }];
        return items.map((item) => {
          const clean = { id: item.id, quantity: item.quantity };
          if (item.properties && Object.keys(item.properties).length) clean.properties = item.properties;
          return clean;
        });
      },

      reset(sectionId) {
        pdp.personalizations(sectionId).forEach((el) => typeof el.reset === 'function' && el.reset());
      },

      applyUpdates(doc) {
        doc.querySelectorAll('[data-pdp-update]').forEach((source) => {
          const key = source.dataset.pdpUpdate;
          document.querySelectorAll(`[data-pdp-update="${CSS.escape(key)}"]`).forEach((target) => {
            target.innerHTML = source.innerHTML;
          });
        });
      },

      /* Re-renders every [data-pdp-update] region of the section for the new selection. */
      async changeVariant({ sectionId, productUrl, variantId, optionValueIds }) {
        const previous = controllers.get(sectionId);
        if (previous) previous.abort();
        const controller = new AbortController();
        controllers.set(sectionId, controller);

        const params = new URLSearchParams({ section_id: sectionId });
        if (variantId) params.set('variant', variantId);
        else if (optionValueIds?.length) params.set('option_values', optionValueIds.join(','));

        let doc;
        try {
          const response = await fetch(`${productUrl}?${params}`, { signal: controller.signal });
          if (!response.ok) throw new Error(String(response.status));
          doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        } catch (error) {
          if (error.name === 'AbortError') return null;
          if (variantId) window.location.assign(`${productUrl}?variant=${variantId}`);
          return null;
        }

        const focusedValue = document.activeElement?.dataset?.optionValueId;
        pdp.applyUpdates(doc);
        if (focusedValue) {
          document.querySelector(`[data-section-id="${sectionId}"] [data-option-value-id="${focusedValue}"]`)?.focus();
        }

        let variant = null;
        try {
          variant = JSON.parse(doc.querySelector('[data-pdp-variant]')?.textContent || 'null');
        } catch (error) {
          variant = null;
        }

        const form = pdp.form(sectionId);
        const idInput = form?.querySelector('input[name="id"]');
        if (idInput && variant) idInput.value = variant.id;
        if (variant) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        const section = document.querySelector(`.sx-pdp[data-section-id="${sectionId}"]`);
        document.dispatchEvent(
          new CustomEvent(eventName('variantChanged', 'sx:variant-changed'), {
            detail: { sectionId, productId: section?.dataset.productId, variant },
          }),
        );
        return variant;
      },
    };

    window.SxPdp = pdp;
  })();

  /* A PDP info column is usually taller than the viewport, where plain `position: sticky` never
     visibly sticks. Nudging the sticky offset against the scroll direction pins the column's
     bottom on the way down and its top on the way up, so the buy area stays put while a tall
     image grid scrolls past. Columns that already fit keep the plain top offset. */
  if (!customElements.get('sx-sticky-column')) {
    customElements.define(
      'sx-sticky-column',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.lastY = window.scrollY;
          this.offset = null;
          this.frame = 0;
          this.schedule = () => {
            if (!this.frame) this.frame = requestAnimationFrame(() => this.update());
          };
          window.addEventListener('scroll', this.schedule, { passive: true });
          window.addEventListener('resize', this.schedule, { passive: true });
          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(this.schedule);
            this.observer.observe(this);
          }
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.schedule);
          window.removeEventListener('resize', this.schedule);
          this.observer?.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.bound = false;
        }

        update() {
          this.frame = 0;
          if (getComputedStyle(this).position !== 'sticky') {
            this.style.removeProperty('--sticky-top');
            this.offset = null;
            return;
          }
          const gap = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-gap')) || 24;
          const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const maxTop = header + gap;
          const minTop = window.innerHeight - this.offsetHeight - gap;
          if (minTop >= maxTop) {
            this.style.removeProperty('--sticky-top');
            this.offset = null;
            this.lastY = window.scrollY;
            return;
          }
          const delta = window.scrollY - this.lastY;
          this.lastY = window.scrollY;
          const current = this.offset === null ? maxTop : this.offset;
          this.offset = Math.min(maxTop, Math.max(minTop, current - delta));
          this.style.setProperty('--sticky-top', `${this.offset}px`);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-product-recommendations')) {
    customElements.define(
      'sx-product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.children.length || !this.dataset.url || this.loading) return;
          if (!('IntersectionObserver' in window)) {
            this.load();
            return;
          }
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.load();
            },
            { rootMargin: '0px 0px 600px 0px' },
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        async load() {
          this.loading = true;
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) throw new Error(String(response.status));
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = doc.querySelector('sx-product-recommendations');
            if (fresh && fresh.innerHTML.trim()) {
              this.innerHTML = fresh.innerHTML;
            } else {
              this.hidden = true;
            }
          } catch (error) {
            this.hidden = true;
          } finally {
            this.loading = false;
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-promo-popup')) {
    const STORAGE_KEY = 'sx-promo-popup';
    const DAY_MS = 86400000;
    /* Popups are never shown on page load: every trigger waits at least this long. */
    const MIN_DELAY_MS = 4000;
    const selectedSections = new Set();

    const readRecord = () => {
      try {
        const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    };

    const writeRecord = (record) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readRecord(), ...record }));
      } catch (error) {
        /* Storage unavailable (private mode / blocked): the popup simply re-arms next visit. */
      }
    };

    const shouldShow = (days) => {
      const record = readRecord();
      if (record.subscribed) return false;
      if (!record.dismissedAt) return true;
      return Date.now() - record.dismissedAt >= Math.max(days, 0) * DAY_MS;
    };

    customElements.define(
      'sx-promo-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.modal = this.querySelector('sx-modal');
          this.dialog = this.querySelector('dialog');
          if (!this.modal || !this.dialog) return;
          this.sectionId = this.dataset.sectionId;
          this.cleanups = [];

          this.querySelectorAll('[data-promo-dismiss]').forEach((link) => link.addEventListener('click', () => this.markDismissed()));
          this.dialog.addEventListener('close', () => this.markDismissed());
          this.addEventListener('sx:newsletter-submit', () => writeRecord({ subscribed: true, dismissedAt: Date.now() }));
          if (this.querySelector('[data-nl-success]')) this.revealReward();

          if (window.Shopify && window.Shopify.designMode) {
            this.setupEditor();
            return;
          }
          if (this.dataset.enabled !== 'true') return;

          // Returning from a posted popup form (Shopify redirects to #form-id): show the result right away.
          if (window.location.hash === `#${this.dataset.formId}`) {
            if (this.querySelector('[data-nl-success]')) writeRecord({ subscribed: true, dismissedAt: Date.now() });
            requestAnimationFrame(() => this.show());
            return;
          }

          if (shouldShow(Number(this.dataset.days) || 7)) this.arm();
        }

        disconnectedCallback() {
          this.disarm();
          if (this.onSelect) {
            document.removeEventListener('shopify:section:select', this.onSelect);
            document.removeEventListener('shopify:section:deselect', this.onDeselect);
          }
        }

        /* The form posts and Shopify reloads the page, so the success state is server-rendered;
           swap the sign-up prompt for the reward as soon as we see it. */
        revealReward() {
          const reward = this.querySelector('[data-promo-reward]');
          if (reward) reward.hidden = false;
          const signup = this.querySelector('[data-promo-signup]');
          if (signup && reward) signup.hidden = true;
        }

        markDismissed() {
          if (window.Shopify && window.Shopify.designMode) return;
          writeRecord({ dismissedAt: Date.now() });
        }

        show() {
          if (this.dialog.open) return;
          this.modal.open(document.activeElement);
        }

        arm() {
          const mountedAt = Date.now();
          let fired = false;
          const fire = () => {
            if (fired || Date.now() - mountedAt < MIN_DELAY_MS) return;
            fired = true;
            this.disarm();
            // Showing counts as an impression for the frequency window, even if the tab is closed.
            this.markDismissed();
            this.show();
          };

          let mode = this.dataset.trigger;
          if (mode === 'exit' && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) mode = 'scroll';

          if (mode === 'delay') {
            const id = window.setTimeout(fire, Math.max((Number(this.dataset.delay) || 15) * 1000, MIN_DELAY_MS));
            this.cleanups.push(() => window.clearTimeout(id));
          } else if (mode === 'scroll') {
            const target = Math.min(Math.max(Number(this.dataset.scroll) || 40, 1), 100) / 100;
            const onScroll = () => {
              const max = document.documentElement.scrollHeight - window.innerHeight;
              if (max > 0 && window.scrollY / max >= target) fire();
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            this.cleanups.push(() => window.removeEventListener('scroll', onScroll));
          } else {
            const onOut = (event) => {
              if (!event.relatedTarget && event.clientY <= 0) fire();
            };
            document.addEventListener('mouseout', onOut);
            this.cleanups.push(() => document.removeEventListener('mouseout', onOut));
          }
        }

        disarm() {
          (this.cleanups || []).forEach((off) => off());
          this.cleanups = [];
        }

        /* Theme editor: preview while the section is selected; never auto-trigger. */
        setupEditor() {
          this.onSelect = (event) => {
            if (event.detail?.sectionId !== this.sectionId) return;
            selectedSections.add(this.sectionId);
            this.show();
          };
          this.onDeselect = (event) => {
            if (event.detail?.sectionId !== this.sectionId) return;
            selectedSections.delete(this.sectionId);
            this.modal.close();
          };
          document.addEventListener('shopify:section:select', this.onSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
          // A settings change re-renders the section (shopify:section:load): reopen if it is still selected.
          if (selectedSections.has(this.sectionId)) requestAnimationFrame(() => this.show());
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-review-ticker')) {
    customElements.define(
      'sx-review-ticker',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.rtk__track');
          this.group = this.querySelector('.rtk__group');
          this.set = this.querySelector('.rtk__set');
          if (!this.track || !this.set) return;

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.syncFocusable = this.syncFocusable.bind(this);
          this.reduced.addEventListener('change', this.syncFocusable);
          this.syncFocusable();
          this.build();

          this.onBlockSelect = (event) => {
            if (this.set.contains(event.target)) this.classList.add('is-paused');
          };
          this.onBlockDeselect = (event) => {
            if (this.set.contains(event.target)) this.classList.remove('is-paused');
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        disconnectedCallback() {
          this.reduced?.removeEventListener('change', this.syncFocusable);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        /* Reduced motion turns the viewport into a scroller: keyboard-focusable only then. */
        syncFocusable() {
          if (this.reduced.matches) this.setAttribute('tabindex', '0');
          else this.removeAttribute('tabindex');
        }

        hideClone(node) {
          node.setAttribute('aria-hidden', 'true');
          node.inert = true;
          node.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          node.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        }

        build() {
          const count = this.set.children.length;
          if (!count) return;
          // Each group repeats the list until it holds at least 6 cards, so short lists fill wide screens.
          const repeat = Math.ceil(6 / count);
          for (let i = 1; i < repeat; i += 1) {
            const dup = this.set.cloneNode(true);
            dup.classList.add('rtk__set--dup');
            this.hideClone(dup);
            this.group.append(dup);
          }
          const copy = this.group.cloneNode(true);
          copy.classList.add('rtk__group--copy');
          this.hideClone(copy);
          this.track.append(copy);

          const speed = Math.min(Math.max(Number(this.dataset.speed) || 40, 10), 120);
          this.closest('.rtk')?.style.setProperty('--rtk-duration', `${speed * repeat}s`);
          this.classList.add('is-ready');
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-progress"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-scroll-progress')) {
    customElements.define(
      'sx-scroll-progress',
      class extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('.spg__bar');
          if (!this.bar) return;
          this.frame = 0;
          this.paint = this.paint.bind(this);
          this.schedule = this.schedule.bind(this);
          this.abort = new AbortController();
          const { signal } = this.abort;
          window.addEventListener('scroll', this.schedule, { passive: true, signal });
          window.addEventListener('resize', this.schedule, { passive: true, signal });
          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.schedule);
            this.resizeObserver.observe(document.body);
          }
          this.paint();
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        schedule() {
          if (!this.frame) this.frame = requestAnimationFrame(this.paint);
        }

        paint() {
          this.frame = 0;
          /* While a drawer or modal locks the page, scrollHeight and scrollY are unreliable and the
             bar would flash across the screen. Freeze it at its last value until the overlay closes. */
          if (document.documentElement.classList.contains('sx-scroll-locked')) return;
          const max = document.documentElement.scrollHeight - window.innerHeight;
          const progress = max > 0 ? Math.min(Math.max(window.scrollY / max, 0), 1) : 0;
          this.bar.style.transform = `scaleX(${progress})`;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-testimonials')) {
    customElements.define(
      'sx-testimonials',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-tst-track]');
          if (!this.track) return;
          this.nav = this.querySelector('[data-tst-nav]');
          this.bar = this.querySelector('[data-tst-bar]');
          this.prev = this.querySelector('[data-tst-prev]');
          this.next = this.querySelector('[data-tst-next]');
          this.update = this.update.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);
          this.prev.addEventListener('click', () => this.scrollPage(-1));
          this.next.addEventListener('click', () => this.scrollPage(1));
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        update() {
          const el = this.track;
          const max = el.scrollWidth - el.clientWidth;
          const canPrev = el.scrollLeft > 2;
          const canNext = el.scrollLeft < max - 2;
          const progress = max > 0 ? el.scrollLeft / max : 1;
          const visible = el.scrollWidth > 0 ? Math.min(1, el.clientWidth / el.scrollWidth) : 1;
          this.nav.hidden = !(canPrev || canNext);
          this.prev.disabled = !canPrev;
          this.next.disabled = !canNext;
          this.bar.style.width = `${visible * 100}%`;
          this.bar.style.transform = `translateX(${(progress * (1 - visible) * 100) / (visible || 1)}%)`;
        }

        scrollPage(direction) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
        }

        onBlockSelect(event) {
          const block = event.target;
          if (!(block instanceof HTMLElement) || !this.track.contains(block)) return;
          this.track.scrollTo({ left: block.offsetLeft - this.track.offsetLeft, behavior: event.detail?.load ? 'auto' : 'smooth' });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-ugc-videos')) {
    customElements.define(
      'sx-ugc-videos',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ugc-track]');
          this.arrows = this.querySelector('[data-ugc-arrows]');
          this.prev = this.querySelector('[data-ugc-prev]');
          this.next = this.querySelector('[data-ugc-next]');
          this.modal = this.querySelector('sx-modal');
          this.dialog = this.querySelector('[data-ugc-dialog]');
          this.storyVideo = this.querySelector('[data-ugc-story-video]');
          this.storyCaption = this.querySelector('[data-ugc-story-caption]');
          this.storyProduct = this.querySelector('[data-ugc-story-product]');
          if (!this.track) return;

          this.updateEdges = this.updateEdges.bind(this);
          this.onOpen = this.onOpen.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);
          this.prev?.addEventListener('click', () => this.scrollPage(-1));
          this.next?.addEventListener('click', () => this.scrollPage(1));
          this.track.addEventListener('scroll', this.updateEdges, { passive: true });
          this.addEventListener('sx:ugc-open', this.onOpen);
          this.dialog?.addEventListener('close', () => this.onClose());
          this.resizeObserver = new ResizeObserver(this.updateEdges);
          this.resizeObserver.observe(this.track);
          if (this.track.firstElementChild) this.resizeObserver.observe(this.track.firstElementChild);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          this.updateEdges();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        updateEdges() {
          if (!this.arrows) return;
          const el = this.track;
          const max = el.scrollWidth - el.clientWidth;
          const canPrev = el.scrollLeft > 2;
          const canNext = el.scrollLeft < max - 2;
          this.arrows.hidden = !(canPrev || canNext);
          this.prev.disabled = !canPrev;
          this.next.disabled = !canNext;
        }

        scrollPage(direction) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * this.track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
        }

        onBlockSelect(event) {
          const block = event.target;
          if (!(block instanceof HTMLElement) || !this.track.contains(block)) return;
          this.track.scrollTo({ left: block.offsetLeft - this.track.offsetLeft - 16, behavior: 'smooth' });
        }

        async onOpen(event) {
          const { videoSrc, posterSrc, caption, productTemplate, opener } = event.detail || {};
          if (!videoSrc || !this.modal || !this.storyVideo) return;
          event.stopPropagation();

          this.storyVideo.poster = posterSrc || '';
          this.storyVideo.src = videoSrc;
          this.storyCaption.textContent = caption || '';
          this.storyCaption.hidden = !caption;
          if (caption) this.dialog.setAttribute('aria-labelledby', this.storyCaption.id);
          else this.dialog.removeAttribute('aria-labelledby');
          this.storyProduct.replaceChildren();
          if (productTemplate) this.storyProduct.append(productTemplate.content.cloneNode(true));

          this.modal.open(opener);
          // Opened by a user click, so try with sound first; fall back to muted if the browser blocks it.
          this.storyVideo.muted = false;
          try {
            await this.storyVideo.play();
          } catch (error) {
            this.storyVideo.muted = true;
            this.storyVideo.play().catch(() => {});
          }
        }

        onClose() {
          this.storyVideo.pause();
          this.storyVideo.removeAttribute('src');
          this.storyVideo.load();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sx-video-section')) {
    customElements.define(
      'sx-video-section',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('.vsec__frame');
          this.video = this.querySelector('.vsec__video');
          this.toggle = this.querySelector('.vsec__toggle');
          if (!this.frame || !this.video || !this.toggle) return;

          this.autoplay = this.dataset.autoplay === 'true';
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.userPaused = false;
          this.requested = false;
          this.visible = false;
          this.abort = new AbortController();
          const { signal } = this.abort;

          this.video.addEventListener('playing', () => this.setPlaying(true), { signal });
          this.video.addEventListener('pause', () => this.setPlaying(false), { signal });
          this.video.addEventListener('ended', () => this.setPlaying(false), { signal });
          this.toggle.addEventListener('click', () => this.onToggle(), { signal });
          this.motionQuery.addEventListener('change', () => this.sync(), { signal });

          if ('IntersectionObserver' in window) {
            /* The source is attached only near the viewport (or once the visitor asks to play). */
            this.nearObserver = new IntersectionObserver((entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.loadSource();
              this.nearObserver.disconnect();
              this.sync();
            }, { rootMargin: '300px 0px' });
            this.nearObserver.observe(this.frame);

            this.viewObserver = new IntersectionObserver((entries) => {
              this.visible = entries[entries.length - 1].isIntersecting;
              this.sync();
            }, { threshold: 0.35 });
            this.viewObserver.observe(this.frame);
          } else {
            this.loadSource();
          }
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.nearObserver?.disconnect();
          this.viewObserver?.disconnect();
        }

        get shouldAutoplay() {
          return this.autoplay && !this.motionQuery.matches;
        }

        loadSource() {
          if (this.video.getAttribute('src')) return;
          this.video.muted = this.shouldAutoplay && !this.requested;
          this.video.src = this.video.dataset.src;
        }

        play() {
          return this.video.play().catch(() => undefined);
        }

        sync() {
          if (!this.video.getAttribute('src')) return;
          if (this.requested && !this.userPaused) {
            this.play();
            return;
          }
          if (!this.shouldAutoplay || this.userPaused) return;
          if (this.visible) this.play();
          else this.video.pause();
        }

        onToggle() {
          if (this.video.paused) {
            this.userPaused = false;
            this.requested = true;
            this.loadSource();
            this.video.muted = false;
            this.play();
          } else {
            this.userPaused = true;
            this.requested = false;
            this.video.pause();
          }
        }

        setPlaying(playing) {
          this.frame.classList.toggle('is-playing', playing);
          this.toggle.setAttribute('aria-pressed', String(playing));
          this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
